import { annotationLatinCopy } from '@/i18n/image-annotation-latin-copy';
import { annotationAsianCopy } from '@/i18n/image-annotation-asian-copy';
import { annotationOtherCopy } from '@/i18n/image-annotation-other-copy';
import { normalizeLocale, type SupportedLocale } from '@/i18n/config';
import { getImageRegionEditCopy } from '@/i18n/image-region-edit-copy';

export const ANNOTATION_COPY_KEYS = [
  'select',
  'arrow',
  'line',
  'text',
  'rect',
  'ellipse',
  'ink',
  'highlighter',
  'counter',
  'blur',
  'pixelate',
  'spotlight',
  'magnifier',
  'ruler',
  'image',
  'eyedropper',
  'annotate',
  'send',
  'undo',
  'redo',
  'remove',
  'color',
  'width',
  'fontSize',
  'fill',
  'label',
  'zoomIn',
  'zoomOut',
  'fit',
  'error',
  'loading',
  'defaultPrompt',
  'attached',
  'cancel',
] as const;
export type ImageAnnotationCopy = Record<
  (typeof ANNOTATION_COPY_KEYS)[number],
  string
>;
// Column order follows ANNOTATION_COPY_KEYS; completeness is checked in the locale test.
export const IMAGE_ANNOTATION_TRANSLATIONS: Record<SupportedLocale, string[]> =
  {
    ...annotationLatinCopy,
    ...annotationAsianCopy,
    ...annotationOtherCopy,
  };
export const getImageAnnotationCopy = (locale: string): ImageAnnotationCopy => {
  const values = IMAGE_ANNOTATION_TRANSLATIONS[normalizeLocale(locale)];
  return Object.fromEntries(
    ANNOTATION_COPY_KEYS.map(
      (
        key: keyof ImageAnnotationCopy,
        i: number
      ): [keyof ImageAnnotationCopy, string | undefined] => [key, values[i]]
    )
  ) as ImageAnnotationCopy;
};

/** Labels for every annotation tool and mark kind, including region edits. */
export const getImageAnnotationToolLabels = (locale: string) => {
  const region = getImageRegionEditCopy(locale);
  return {
    ...getImageAnnotationCopy(locale),
    region: region.region,
    motif: region.motif,
  };
};
